import React from 'react';

import { BarProps } from '../types';

import { Background, Indicator, Wrapper } from './styles';

export const Bar: React.FC<BarProps> = ({ durationMs }) => {
  return (
    <Wrapper>
      <Background>
        <Indicator duration={durationMs} />
      </Background>
    </Wrapper>
  );
};
